import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const UsersSkeleton = () => {
  return (
    <div className="space-y-4 w-full">
      {[...Array(6)].map((_, i) => (
        <div key={i} className="flex items-center space-x-4">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="space-y-2 w-full">
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const UserSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="h-12 w-[200px]" />
    <Card>
      <CardHeader>
        <Skeleton className="h-8 w-[150px]" />
      </CardHeader>
      <CardContent className="space-y-4">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </CardContent>
    </Card>
  </div>
);

export const ClientSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="h-12 w-[200px]" />
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-1">
        <Card>
          <CardHeader>
            <Skeleton className="h-8 w-[150px]" />
          </CardHeader>
          <CardContent className="space-y-4">
            <Skeleton className="h-20 w-20 rounded-full mx-auto" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </CardContent>
        </Card>
      </div>
      <div className="col-span-2">
        <Card>
          <CardHeader>
            <Skeleton className="h-8 w-[150px]" />
          </CardHeader>
          <CardContent>
            <Skeleton className="h-[200px] w-full" />
          </CardContent>
        </Card>
      </div>
    </div>
  </div>
);
